export enum PFlexJustify {
  START = 'start',
  END = 'end',
  CENTER = 'center',
  BETWEEN = 'between',
  AROUND = 'around',
  EVENLY = 'evenly',
}

export enum PFlexAlign {
  START = 'start',
  END = 'end',
  CENTER = 'center',
  STRETCH = 'stretch',
  BASELINE = 'baseline',
}

export enum PFlexDirection {
  ROW = 'row',
  COLUMN = 'column',
}

export enum PFlexSticky {
  START = 'start',
  END = 'end',
}

export enum PFlexSize {
  HUG = 'hug',
  FILL = 'fill',
}

export type PFlexItemSize = number | PFlexSize
